export default __webpack_public_path__ + "static/media/bg.fce49580.svg";